import { setFeedback, delayedClearFeedback } from './feedback';
import { activeStepCheckout, activeStepCreate } from './active_enroll_step';
import { closeModal } from './active_modal';
import { setCustomer } from './customer';
import { fireEnrollShippingSuccess, clearEnrollShippingSuccess } from './enroll_shipping_success';
import { clearEnrollPaymentSuccess } from './enroll_payment_success';
import { setAccountCreationError, clearAccountCreationError } from './account_creation_error';
import { getCustomerPaymentMethods, upgradePaymentHelper } from './payment_methods'
import { setBraintreeFailure } from './braintree_failure';
import request from 'superagent';

export function enrollCreateShipping(oUpdate, failFunction, finalFunction) {
	return dispatch => {
    request
      .post('/svc/customer/enrollCreateShipping')
      .send(oUpdate)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200 ) {
          dispatch([
            clearEnrollShippingSuccess(),
            setFeedback( err.message || 'Sorry, an error occurred. Please try again.'),
            delayedClearFeedback(),
            setCustomer(res.body)
          ]);
          failFunction();
        }
        dispatch([
          fireEnrollShippingSuccess(),
          setCustomer(res.body)
        ]);
        finalFunction();
      });
	}
}

export function enrollCreateAccount(oaddCustomer) {
  return ( dispatch, getState ) => {
    let newCustomer = { ...getState().customer, ... oaddCustomer.customer};
    dispatch( setCustomer(newCustomer) );
    request
      .post('/svc/customer/enrollCreateAccount')
      .send(oaddCustomer)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
           return dispatch([
            activeStepCreate(),
            setFeedback( 
              res.text || err.response.text || 'Sorry, an error occurred. Please try again.' 
            ),
            delayedClearFeedback(),
            setAccountCreationError(res.text || err.response.text),
            setCustomer( {} )
          ]);
        }
        return dispatch([
          activeStepCheckout(),
          clearAccountCreationError(),
          setCustomer(res.body)
        ]);
      });
	}
}

export function upgradeCreateAccount(oaddCustomer, shipping, payment=null, paySuccess, failFunction, skipPayment=false) {
  return ( dispatch, getState ) => {
    let newCustomer = { ...getState().customer, ...oaddCustomer};
    dispatch( setCustomer(newCustomer) );
    let bodyObj = { customer: oaddCustomer, shipping_address: shipping };
    if(payment) bodyObj.payment = payment;
    request
      .post('/svc/customer/upgradeCreateAccount')
      .send(bodyObj)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
          dispatch([
            setFeedback( err.message || 'Sorry, an error occurred. Please try again.' ),
            setBraintreeFailure(err.message),
            delayedClearFeedback(),
            clearEnrollShippingSuccess(),
            clearEnrollPaymentSuccess(),
            setAccountCreationError(err.message)
          ]);
          return failFunction();
        }

        dispatch([
          fireEnrollShippingSuccess(),
          clearAccountCreationError(),
          setCustomer(res.body)
        ]);
        if(skipPayment) return setTimeout( paySuccess(), 1000);
        else return dispatch(  upgradePaymentHelper(paySuccess, failFunction) );
      });
  }
}




// WEBPACK FOOTER //
// ./src/modules/enroll_actions.js